<template>
    <div>
        <div class="row">
            <div class="col-12">
            <router-link class="ml-1" to=""><div @click="$router.back()">Back</div></router-link>
            </div>
        </div>
        <div class="row" v-if="mobile">
            <div class="col-lg-12 col-xl-7">
                <card :title="`${mobile.vendor} ${mobile.model} ${mobile.serial}`">
                    <template v-slot:header-right>
                        <button @click="fetchCertificate" class="btn btn-sm btn-outline-info" :class="!isValid ? 'disabled' : ''">Certificate</button>
                    </template>
                    <div class="card-body">
                        <small class="ml-2">Checksum {{ mobile.hash }}</small>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <th>Created at</th>
                                    <td>{{ mobile.created_at | prettyDateTime }}</td>
                                </tr>
                                <tr>
                                    <th>Updated at</th>
                                    <td>{{ mobile.updated_at | prettyDateTime }}</td>
                                </tr>
                                <tr>
                                    <th>Uploaded at</th>
                                    <td>{{ mobile.uploaded_at | prettyDateTime }}</td>
                                </tr>
                                <tr>
                                    <th>Report revision</th>
                                    <td>{{ mobile.revision }}</td>
                                </tr>
                                <tr>
                                    <th>Software version</th>
                                    <td>{{ mobile.software_version }}</td>
                                </tr>
                                <tr>
                                    <th>Report ID</th>
                                    <td>{{ mobile.report_id }}</td>
                                </tr>
                                <tr>
                                    <th>Batch name</th>
                                    <td>{{ mobile.batch_name }}</td>
                                </tr>
                                <tr>
                                    <th>Vendor</th>
                                    <td>{{ mobile.vendor }}</td>
                                </tr>
                                <tr>
                                    <th>Model</th>
                                    <td>{{ mobile.model }}</td>
                                </tr>
                                <tr>
                                    <th>Model code</th>
                                    <td>{{ mobile.model_code }}</td>
                                </tr>
                                <tr>
                                    <th>Serial</th>
                                    <td>{{ mobile.serial }}</td>
                                </tr>
                                <tr>
                                    <th>Platform</th>
                                    <td>{{ mobile.platform }}</td>
                                </tr>
                                <tr>
                                    <th>OS version</th>
                                    <td>{{ mobile.os_version }}</td>
                                </tr>
                                <tr>
                                    <th>Color</th>
                                    <td>{{ mobile.color }}</td>
                                </tr>
                                <tr>
                                    <th>Internal storage capacity</th>
                                    <td>{{ mobile.internal_storage_capacity_display }}</td>
                                </tr>
                                <tr>
                                    <th>IMEI 1</th>
                                    <td>{{ mobile.international_mobile_equipment_identity1 }}</td>
                                </tr>
                                <tr>
                                    <th>IMEI 2</th>
                                    <td>{{ mobile.international_mobile_equipment_identity2 }}</td>
                                </tr>
                                <tr>
                                    <th>IMEI 3</th>
                                    <td>{{ mobile.international_mobile_equipment_identity3 }}</td>
                                </tr>
                                <tr>
                                    <th>IMEI 4</th>
                                    <td>{{ mobile.international_mobile_equipment_identity4 }}</td>
                                </tr>
                                <tr>
                                    <th>MEID 1</th>
                                    <td>{{ mobile.mobile_equipment_identifier1 }}</td>
                                </tr>
                                <tr>
                                    <th>MEID 2</th>
                                    <td>{{ mobile.mobile_equipment_identifier2 }}</td>
                                </tr>
                                <tr>
                                    <th>MEID 3</th>
                                    <td>{{ mobile.mobile_equipment_identifier3 }}</td>
                                </tr>
                                <tr>
                                    <th>MEID 4</th>
                                    <td>{{ mobile.mobile_equipment_identifier4 }}</td>
                                </tr>
                                <tr>
                                    <th>Battery cycle count</th>
                                    <td>{{ mobile.battery_cycle_count }}</td>
                                </tr>
                                <tr>
                                    <th>Battery capacity</th>
                                    <td>{{ mobile.battery_capacity }}</td>
                                </tr>
                                <tr>
                                    <th>Battery design capacity</th>
                                    <td>{{ mobile.battery_design_capacity }}</td>
                                </tr>
                                <tr>
                                    <th>Battery health</th>
                                    <td>{{ mobile.battery_health }}</td>
                                </tr>
                                <tr>
                                    <th>Erase method</th>
                                    <td>{{ mobile.erase_algorithm_display }}</td>
                                </tr>
                                <tr>
                                    <th>Erase result</th>
                                    <td>{{ mobile.erase_result_display }}</td>
                                </tr>
                                <tr>
                                    <th>Erase start time</th>
                                    <td v-if="mobile.erase_start_time">{{ mobile.erase_start_time | prettyDateTime }}</td>
                                    <td v-else></td>
                                </tr>
                                <tr>
                                    <th>Erase finish time</th>
                                    <td v-if="mobile.erase_finish_time">{{ mobile.erase_finish_time | prettyDateTime }}</td>
                                    <td v-else></td>
                                </tr>
                                <tr>
                                    <th>Block list</th>
                                    <td>{{ mobile.block_list }}</td>
                                </tr>
                                <tr>
                                    <th>MDM lock</th>
                                    <td>{{ mobile.mdm_lock }}</td>
                                </tr>
                                <tr v-if="mobile.platform === 'iOS'">
                                    <th>Find my iPhone</th>
                                    <td>{{ mobile.find_my_iphone }}</td>
                                </tr>
                                <tr v-if="mobile.platform === 'iOS'">
                                    <th>Model number</th>
                                    <td>{{ mobile.model_number }}</td>
                                </tr>
                                <tr v-if="mobile.platform === 'Android'">
                                    <th>SDK version</th>
                                    <td>{{ mobile.android_sdk_version }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </card>
            </div>
            <div class="col-lg-12 col-xl-5">
                <toggle-card :title="`Extra (${mobile.extra.length || 0})`" showInitially>
                    <button v-if="isLocked" class="btn btn-sm btn-outline-info float-right mb-1" type="button"
                        @click="unlock()">Edit</button>
                    <b-table v-if="isLocked" thead-class="d-none" show-empty small :items="mobile.extra"
                        :fields="[{ key: 'key', isRowHeader: true }, 'value']"></b-table>
                    <extras-form v-else @close="lock()" @save="saveExtras" :items="mobile.extra"></extras-form>
                </toggle-card>
                <toggle-card :title="`Log (${mobile.log.length || 0})`" showInitially>
                    <b-table show-empty small :items="mobile.log" :fields="['level', 'message']">
                        <template v-slot:cell(level)="row">
                            <div v-if="row.item.level == 0">DEBUG</div>
                            <div v-if="row.item.level == 1">INFO</div>
                            <div v-if="row.item.level == 2">WARNING</div>
                            <div v-if="row.item.level == 3">ERROR</div>
                        </template>
                    </b-table>
                </toggle-card>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-11">
                <card title="mobile" subTitle="404 error" :isFullPage="true">
                    <div class="card-body text-center">
                        <p>No mobile was found at this url</p>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import { notify } from '../services/notify';

import api from '../services/api';
import ToggleCard from '../components/Cards/ToggleCard.vue';
import ExtrasForm from '../components/Forms/ExtrasForm.vue';

export default {
    name: "mobileErased",
    components: {
        ExtrasForm,
        ToggleCard,
    },
    props: {
        mobile_id: String,
    },
    data() {
        return {
            mobile: null,
            isLoading: false,
            isLocked: true,
        };
    },
    async created() {
        this.isLoading = true;
        try {
            const response = await api.get(`/mobile-devices/${this.mobile_id}`);
            this.mobile = response.data;
        }
        catch(err) {
            notify().error('Error fetching report.');
        }
        finally {
            this.isLoading = false;
        }
    },
    methods: {
        async unlock() {
            this.isLocked = false;
        },
        async lock() {
            this.isLocked = true;
        },
        async saveExtras(extras) {
            this.isLoading = true;
            try {
                const response = await api.put(`/mobile-devices/${this.mobile_id}`, extras);
                this.mobile = response.data;
            }
            catch(err) {
                notify().error('Error saving report.');
            }
            finally {
                this.isLoading = false;
            }
        },
        async fetchCertificate() {
            this.isLoading = true;
            try {
                const response = await api.postJSON('/mobile-devices/export', {
                    type: 'certificate',
                    selection: [this.mobile.mobile_id],
                    filename: `${this.mobile.report_id}.pdf`,
                }, { responseType: 'blob' });
                const url = window.URL.createObjectURL(response.data);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${this.mobile.report_id}.pdf`;
                a.click();
                window.URL.revokeObjectURL(url);
            }
            catch(err) {
                notify().error('Error fetching certificate.');
            }
            finally {
                this.isLoading = false;
            }
        },
    },
    computed: {
        isValid() {
            return !(this.mobile.hash == null || this.mobile.hash == "" || this.mobile.hash == "INVALID");
        },
    }
};
</script>
